module.exports = __webpack_public_path__ + "static/media/1002235.f407562c.png";